import React, {Component} from 'react';
import {Grid} from 'react-bootstrap';
import {connect} from 'react-redux';

class Body extends Component {
    
    render(){
        let date = new Date();
        
        return (
            <Grid>
                <main>
                    {this.props.children}
                </main>
                <footer>
                    <hr />
                    <p>&copy; <a href='http://hive-iot.com'>Hive IoT</a> {date.getFullYear()} - Powered by <a href='http://hive-infinity.com'>Hive Infinity</a></p>
                </footer>
            </Grid>
        );
    }
}

export default connect()(Body);